import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/device_update/package/";

export class RemoveUpdatePackageCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "delete";

    constructor(fileToRemove: string) {
        super();
        this.endPoint += fileToRemove;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand();
        return new ApiGenericResponse(res);
    }
}
